export default __webpack_public_path__ + "5e94fa152eb1919b7ecad020334cad26.svg";